
<ng-container *ngIf="isGeneratingReport">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-container>
<br/>
<div class="year-select-container">
  <mat-form-field>
    <mat-label>Fraternal Year</mat-label>
    <mat-select [(value)]="selectedFraternalYear">
      <mat-option value="2023-2024">2023-2024</mat-option>
    </mat-select>
  </mat-form-field>
</div>
<br/>
Council: <input type="number" inputmode="numeric" min="0" #councilId ><br><br>
<button mat-raised-button color="primary" [disabled]="isGeneratingReport" (click)="generateCouncilReport(councilId.value)">Generate Council Report</button>
<br/><br/>
<mat-divider></mat-divider>
<br/>
<ng-container><h3>Director Reports:</h3></ng-container>

<ng-container *ngIf="isReportAdmin || isFaithDirector">
  <button mat-raised-button color="primary" [disabled]="isGeneratingReport" (click)="generateDirectorReport('faith')">Generate Faith Director Report</button>
  <br/><br/>
</ng-container>
<ng-container *ngIf="isReportAdmin || isFamilyDirector">
  <button mat-raised-button color="primary" [disabled]="isGeneratingReport" (click)="generateDirectorReport('family')">Generate Family Director Report</button>
  <br/><br/>
</ng-container>
<ng-container *ngIf="isReportAdmin || isCommunityDirector">
  <button mat-raised-button color="primary" [disabled]="isGeneratingReport" (click)="generateDirectorReport('community')">Generate Community Director Report</button>
  <br/><br/>
</ng-container>
<ng-container *ngIf="isReportAdmin || isLifeDirector">
  <button mat-raised-button color="primary" [disabled]="isGeneratingReport" (click)="generateDirectorReport('life')">Generate Life Director Report</button>
  <br/><br/>
</ng-container>
<ng-container *ngIf="isReportAdmin || isMembershipDirector">
  <button mat-raised-button color="primary" [disabled]="isGeneratingReport" (click)="generateDirectorReport('membership')">Generate Membership Director Report</button>
  <br/><br/>
</ng-container>
<ng-container *ngIf="isReportAdmin">
  <mat-divider></mat-divider>
  <br/>
  <h3>Monthy Report:</h3>
  <button mat-raised-button color="primary" [disabled]="isGeneratingReport" (click)="generateOverallReport()">Generate Overall Report</button>
  <br/><br/>
</ng-container>
<ng-container *ngIf="isAdmin">
  <mat-divider></mat-divider>
  <br/>
  <h3>Membership Growth Data Import:</h3>
  Membership Growth Google Sheet ID: <input type="text" #membershipGrowthGoogleSheetID /><br/><br/>
  <button mat-raised-button color="primary" [disabled]="isGeneratingReport" (click)="consoleLogMembershipGrowthData(membershipGrowthGoogleSheetID.value)">Console Log Data (to verify)</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  <button mat-raised-button color="primary" [disabled]="isGeneratingReport" (click)="importMembershipGrowthData(membershipGrowthGoogleSheetID.value)">Import Membership Growth Data</button>
</ng-container>
